import React from "react";
import PaintSection from "./Sections/PaintSection";
import FloorSection from "./Sections/FloorSection";
import { useParams } from "react-router-dom";


export default function Test({lang}) {

    const param = useParams()

    const id = param.id;
    const data = param.data;

if(Number(id) === 13 ){
    return (
        <div className="min-h-screen mt-[80px]">
      
          <PaintSection colorBlocks={[{color:`#${data}`}]} lang={lang} text={false}  />
          
        </div>
      );
}else if(Number(id) === 14){
    return (
        <div className="min-h-screen mt-[80px]">
    
          <FloorSection FloorBlocks={[{src:data}]} lang={lang} text={false} />
          
        </div>
      );
}else{
    return (
        <div className="min-h-screen">
        {id}
        </div>
      );
}
  
}